import React from 'react';
import { Box, Typography } from '@mui/material';
import Hai from './Hai';
import { sortHais } from '../haiUtils';

const styles = {
  area: {
    padding: '10px',
    border: '2px solid #ccc',
    borderRadius: '5px',
    minHeight: { xs: '35px', sm: '70px' }, // スマホでは高さを35pxに、PCでは70pxに設定
    display: 'flex',
    alignItems: 'center',
    // PCではスクロールを許可し、スマホでは牌を縮小して全体表示
    overflowX: { xs: 'hidden', sm: 'auto' },
  },
  hai: {
    // PCでは最小幅を保証し、スマホでは幅を%で指定して縮小可能に
    width: { xs: '7.14%', sm: 'clamp(32px, 7.1%, 40px)' },
    flexShrink: { xs: 1, sm: 0 }, // スマホでのみ縮小を許可
    height: 'auto',
    padding: '0 2px', // marginの代わりにpaddingを使用
    boxSizing: 'border-box', // paddingを幅に含める
    cursor: 'pointer',
  },
  active: {
    borderColor: '#2196f3', // Blue color to indicate active area
    backgroundColor: '#e3f2fd', // Light blue background
  },
};

const TehaiArea = ({ tehai, onRemove, onAreaSelect, isActive }) => {
  const sortedTehai = sortHais(tehai);

  return (
    <Box sx={{ marginBottom: '10px' }}>
      <Typography variant="subtitle2" gutterBottom>手牌</Typography>
      <Box sx={{ ...styles.area, ...(isActive ? styles.active : {}), cursor: 'pointer' }} onClick={() => onAreaSelect('tehai')}>
        <Box sx={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
          {sortedTehai.map((haiId, index) => (
            <Box
              key={`${haiId}-${index}`}
              sx={styles.hai}
              onClick={(e) => {
                e.stopPropagation();
                onRemove('tehai', index);
              }}
            >
                <Hai haiId={haiId} />
              </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default TehaiArea;